import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { Grid, SvgIcon, Typography, useTheme } from '@mui/material';
import { COLOR_CHATHAMS_BLUE } from 'popTheme';
import { ReactComponent as AboutCalendarLogo } from './about_calendar.svg';
import { ReactComponent as AboutHandLogo } from './about_hand.svg';
import { ReactComponent as AboutResourcesLogo } from './about_resources.svg';
import { ReactComponent as PopLogoEn } from './pop_logo.svg';
import { ReactComponent as PopLogoFr } from './pop_logo_fr.svg';
import { IntroCard } from './IntroCard';

export const Intro = () => {
  const intl = useIntl();
  const theme = useTheme();

  const messages = defineMessages({
    introCardResources: {
      id: 'landing.intro.card.resources.title',
      defaultMessage: 'Access Recommended Resources On The Go!',
      description: 'Title for card that describes Access',
    },
    introCardTrack: {
      id: 'landing.intro.card.track.title',
      defaultMessage: 'Track Your Progress',
      description: 'Title for card that describes Track',
    },
    introCardLearn: {
      id: 'landing.intro.card.learn.title',
      defaultMessage: 'Learn How To Manage Your Pain and Other Symptoms',
      description: 'Title for card that describes Learn',
    },
  });

  return (
    <Grid container direction={'column'} wrap="nowrap">
      <Grid item xs={8}>
        <Grid container direction={'row'}>
          <Grid
            item
            xs={12}
            sm={8}
            sx={{
              [theme.breakpoints.only('xs')]: {
                px: '3.625rem',
                py: '0.625rem',
              },
            }}
          >
            <SvgIcon
              component={intl.locale === 'fr' ? PopLogoFr : PopLogoEn}
              inheritViewBox
              sx={{
                height: { xs: '7.875rem', sm: '6.625rem', md: '10.9375rem', lg: '16.5rem' },
                width: 'auto',
              }}
            />
            <Typography
              variant="body2"
              sx={{
                color: COLOR_CHATHAMS_BLUE,
                [theme.breakpoints.up('xs')]: {
                  py: '3rem',
                  lineHeight: '1.25rem',
                },
                [theme.breakpoints.up('sm')]: {
                  fontSize: '1.25rem',
                  py: '7.5rem',
                  lineHeight: '1.875rem',
                },
              }}
            >
              <FormattedMessage
                id="landing.intro.blurb"
                defaultMessage="Learning to cope with chronic pain can be challenging, but you are not alone on this journey. The Power over Pain Portal, created by researchers, clinicians, and people with lived experience, has a collection of resources, education, and tools to empower youth living with pain. Start today by signing up!"
                description="The blurb for the intro section of the landing page"
              />
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={4} overflow={'auto'}>
        <Grid
          container
          direction="row"
          columnSpacing={{ sm: 8 }}
          sx={{
            positiom: 'absolute',
            minWidth: 'max-content',
            [theme.breakpoints.only('xs')]: {
              pl: '0.75rem',
            },
          }}
        >
          {['introCardResources', 'introCardTrack', 'introCardLearn'].map((messageId, index) => (
            <Grid
              item
              sx={{
                [theme.breakpoints.only('xs')]: {
                  pr: '0.75rem',
                },
              }}
              key={index}
            >
              <IntroCard
                title={intl.formatMessage(messages[messageId])}
                icon={
                  index === 0 ? AboutResourcesLogo : index === 1 ? AboutCalendarLogo : AboutHandLogo
                }
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};
